import React from "react";
import "../css/Navbar.css";
import { AiOutlineHeart } from "react-icons/ai";
import { BsPersonBoundingBox } from "react-icons/bs";
import { BsBagCheckFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

// import TextField from "@mui/material/TextField";

const Navbar = () => {
  let navigate = useNavigate();

  console.log(window.location);

  return (
    <>
      <div className="nav-container">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-dark w-100">
            <a
              className="navbar-brand text-white"
              onClick={() => navigate("/")}
            >
              <img src="/images/logo.svg" alt="Logo Image" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mr-auto ">
                <li
                  className="nav-item "
                  style={{
                    background: window.location.pathname === "/Women" && "#fff",
                  }}
                >
                  <a
                    style={{
                      color: window.location.pathname === "/Women" && "#000",
                    }}
                    className="nav-link "
                    onClick={() => navigate("Women")}
                  >
                    Women
                  </a>
                </li>
                <li
                  className="nav-item"
                  style={{
                    background: window.location.pathname === "/Men" && "#fff",
                  }}
                >
                  <a
                    style={{
                      color: window.location.pathname === "/Men" && "#000",
                    }}
                    className="nav-link"
                    onClick={() => navigate("Men")}
                  >
                    Men
                  </a>
                </li>
                <li
                  className="nav-item"
                  style={{
                    background: window.location.pathname === "/" && "#fff"
                  }}
                >
                  <a
                  style={{
                    color: window.location.pathname === "/" && "#000"
                  }}
                    className="nav-link "
                    onClick={() => navigate("/")}
                  >
                    Kids
                  </a>
                </li>
              </ul>
              <form className="form-inline my-2 my-lg-0">
                <input
                  className="form-control mr-sm-2 "
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
              </form>
              <div className=" icon-Box d-flex">
                <a>
                  <AiOutlineHeart className="text-light mr-2 ml-1 icon" />
                </a>
                <a>
                  <BsPersonBoundingBox className="text-light mr-2 ml-1 icon" />
                </a>
                <a>
                  <BsBagCheckFill className="text-light mr-2 ml-1 icon" />
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbar;
